import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Activity, AlertCircle, Info, MessageCircle } from 'lucide-react';
import { WA_LINK } from '../lib/constants';
export function Services() {
  const services = [{
    icon: <Stethoscope size={32} data-id="element-137" />,
    title: 'Evaluación dental',
    description: 'Orientación inicial para revisar tu caso y entender qué tratamiento podría corresponder.'
  }, {
    icon: <Activity size={32} data-id="element-138" />,
    title: 'Tratamientos dentales generales',
    description: 'Atención para distintas necesidades dentales, según evaluación profesional.'
  }, {
    icon: <AlertCircle size={32} data-id="element-139" />,
    title: 'Urgencias o molestias dentales',
    description: 'Consulta por molestias, dolor o situaciones que requieren orientación dental.'
  }, {
    icon: <Info size={32} data-id="element-140" />,
    title: 'Orientación para pacientes',
    description: 'Explicación clara de alternativas, pasos y próximos cuidados.'
  }];
  return <section id="servicios" className="bg-slate-50 py-20 lg:py-28" data-id="element-141">
      <div className="container mx-auto px-4 md:px-6" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-16 text-center" data-id="element-143">
          <h2 className="text-3xl font-bold tracking-tight text-brand-dark sm:text-4xl" data-id="element-144">
            Servicios dentales
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded bg-brand-accent" data-id="element-145"></div>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-146">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm transition-all hover:shadow-md border border-slate-100" data-id="element-147">
              <div className="p-8 flex-1" data-id="element-148">
                <div className="mb-6 inline-flex rounded-xl bg-brand-light p-4 text-brand-dark" data-id="element-149">
                  {service.icon}
                </div>
                <h3 className="mb-3 text-xl font-semibold text-brand-dark" data-id="element-150">
                  {service.title}
                </h3>
                <p className="text-slate-600" data-id="element-151">{service.description}</p>
              </div>
              <div className="bg-slate-50 p-6 mt-auto border-t border-slate-100" data-id="element-152">
                <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center gap-2 rounded-lg bg-white px-4 py-3 text-sm font-semibold text-brand-dark shadow-sm border border-slate-200 transition-colors hover:bg-slate-50 hover:text-brand-accent" data-id="element-153">
                  <MessageCircle size={18} className="text-[#25D366]" data-id="element-154" />
                  Consultar por WhatsApp
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}